import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogTitle,
} from 'components/common/Dialog';
import IconPen from 'components/icons/IconPen';
import IconButton from 'components/common/IconButton';

import { submit, isSubmitting, isDirty, formValueSelector } from 'redux-form';

import { fetchInventory } from 'redux/modules/inventory';

import InventoryStockLineCreateEditForm from './InventoryStockLineCreateEditForm';

const styles = theme => ({
  dialogPaper: {
    maxWidth: 900,
    minWidth: 900,
  },
  action: {
    '&:first-child': {
      position: 'absolute',
      left: 14,
      top: 8,
    },
  },
  buttonEdit: {
    position: 'absolute',
    top: '50%',
    right: 12,
    transform: 'translateY(-50%)',
    color: theme.palette.primary[500],
  },
  iconPen: {
    width: 15,
    height: 15,
  },
});

const InventoryStockLineCreateEditDialog = ({
  variant,
  form,
  open,
  onClose,
  onSubmitSuccess,
  onCopyButtonClick,
  submitting,
  actions,
  initialValues,
  loading,
  supplyType,
  dirty,
  onWarehouseCreate,
  classes,
  ...otherProps
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    onEnter={() => {
      if (!otherProps['Product Name'] && otherProps['Product ID']) {
        actions.fetchInventory({
          triggerLoading: true,
          ID: otherProps['Product ID'],
        });
      }
    }}
    maxWidth="md"
    classes={{
      paper: classes.dialogPaper,
    }}
  >
    <DialogTitle
      secondaryContent={(
        <IconButton
          className={classes.buttonEdit}
          onClick={() => {}}
          tooltipContent="Edit Product"
        >
          <IconPen className={classes.iconPen} />
        </IconButton>
      )}
    >
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {variant === 'create' ? `${otherProps['Product Name']}: Add Inventory` : 'Edit Inventory'}
      </Typography>
    </DialogTitle>
    <InventoryStockLineCreateEditForm
      variant={variant}
      onSubmitSuccess={(values) => {
        onSubmitSuccess(values);
        onClose();
      }}
      form={form}
      {...initialValues ? { initialValues } : {}}
      supplyType={supplyType}
      onWarehouseCreate={onWarehouseCreate}
      onClose={onClose}
      submitting={submitting}
      dirty={dirty}
      loading={loading}
      {...otherProps}
    />
    
  </Dialog>
);

InventoryStockLineCreateEditDialog.propTypes = {
  variant: PropTypes.oneOf(['create', 'edit']),
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  onCopyButtonClick: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
    fetchInventory: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.string,
  'Product ID': PropTypes.number,
  initialValues: PropTypes.shape({
    'Product ID': PropTypes.number,
    'Hcpc Code ID': PropTypes.number,
  }),
  loading: PropTypes.number.isRequired,
  supplyType: PropTypes.oneOf(['Units', 'Boxes', 'Kcal Units']),
  dirty: PropTypes.bool.isRequired,
  onWarehouseCreate: PropTypes.func,
  classes: PropTypes.shape({
    table: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    dialogContent: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryStockLineCreateEditDialog.defaultProps = {
  variant: 'create',
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
  onCopyButtonClick: null,
  form: 'inventoryStockLineCreate',
  initialValues: null,
  'Product ID': null,
  supplyType: 'Units',
  onWarehouseCreate: () => {},
};

const mapStateToProps = (store, ownProps) => {
  const selector = formValueSelector(ownProps.form);
  let product;
  if (!ownProps['Product Name']
    && ownProps['Product ID']
    && store.inventory.data.find(item => item.ID === ownProps['Product ID'])) {
    product = store.inventory.data.find(item => item.ID === ownProps['Product ID']);
  }
  return {
    submitting: isSubmitting(ownProps.form)(store),
    ...product ? {
      initialValues: {
        'Product ID': product.ID,
        'Hcpc Code ID': product['Main Hcpc Code'].ID,
        'Supply Type': 'Units',
        ...ownProps.initialValues,
      },
      'Product Name': product['Product Name'],
      'Vendor Name': product.Vendor['Vendor Name'],
      Model: product.Model,
      'HCPC Codes': product['HCPC Codes'].map(item => (
        item.map(nestedItem => nestedItem['HCPC S Code'])
      )),
    } : {},
    loading: store.inventory.loading,
    supplyType: selector(store, 'Supply Type'),
    dirty: isDirty(ownProps.form)(store),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit, fetchInventory }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(InventoryStockLineCreateEditDialog),
);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditDialog.js